module.exports = __webpack_public_path__ + "static/img/8.0361977.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/8.png
// module id = y9jO
// module chunks = 0